import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { OfficeLocation } from "@/api/locations";
import { Button } from "@heroui/react";
import { api } from "@/api";
import { toast } from "react-toastify";
import {
  FaPencil,
  FaElevator,
  FaSquare,
  FaRubleSign,
  FaDoorClosed,
  FaLockOpen,
  FaUsers,
} from "react-icons/fa6";
import { Office } from "@/api/offices";
import useErrorHandling from "@/hooks/useErrorHandling";

export function OfficePage() {
  const { id, officeId } = useParams() as { id: string; officeId: string };
  const [location, setLocation] = useState<OfficeLocation | null>(null);
  const [office, setOffice] = useState<Office | null>(null);

  const handleError = useErrorHandling();
  const navigate = useNavigate();

  const openLock = useCallback(() => {
    api.locks
      .unlock(office?.office_lock || 0)
      .then(() => {
        toast.success("Замок успешно открыт!");
      })
      .catch((err) => {
        console.log(err);
        const { errorMessage } = handleError(err);
        toast.error(errorMessage);
      });
  }, [handleError, office?.office_lock]);

  useEffect(() => {
    api.locations
      .get(Number(id))
      .then((response) => {
        setLocation(response.data);
      })
      .catch((err) => {
        console.log(err);
        const { errorMessage } = handleError(err);
        toast.error(errorMessage);
      });

    api.offices
      .get(Number(officeId))
      .then((response) => {
        setOffice(response.data);
      })
      .catch((err) => {
        console.log(err);
        const { errorMessage } = handleError(err);
        toast.error(errorMessage);
      });
  }, [id, setLocation, navigate, officeId, handleError]);

  return (
    <div>
      {location && office && (
        <div className="flex flex-col gap-2 p-2 md:p-4">
          <div className="flex flex-col gap-2 mb-2">
            <span className="text-2xl font-bold">{office.display_name}</span>
            <div className="flex flex-row gap-2 items-center">
              <FaSquare />
              <span className="text-sm">Площадь: {office.area}</span>
            </div>
            <div className="flex flex-row gap-2 items-center">
              <FaRubleSign />
              <span className="text-sm">Цена: {office.price}</span>
            </div>
            <div className="flex flex-row gap-2 items-center">
              <FaElevator />
              <span className="text-sm">Этаж: {office.floor}</span>
            </div>
            <div className="flex flex-row gap-2 items-center">
              <FaDoorClosed />
              <span className="text-sm">
                Количество комнат: {office.room_count}
              </span>
            </div>
            <div className="flex flex-row gap-2 items-center">
              <FaDoorClosed />
              <span className="text-sm">Тип офиса: {office.office_type}</span>
            </div>
            <div className="flex flex-row gap-2 mt-2">
              <Button
                as={Link}
                to={`/dashboard/offices/${officeId}/edit`}
                startContent={<FaPencil />}
                color="primary"
                variant="solid"
                className="max-w-fit">
                Редактировать
              </Button>
              {office.office_type == 7 && (
                <Button
                  as={Link}
                  to={`/dashboard/offices/${officeId}/workplaces`}
                  startContent={<FaUsers />}
                  color="secondary"
                  variant="solid"
                  className="max-w-fit">
                  Рабочие места
                </Button>
              )}
              <Button
                startContent={<FaLockOpen />}
                color="default"
                variant="solid"
                className="max-w-fit"
                onClick={openLock}>
                Открыть замок
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
